import React from 'react';
import { Link, useRouter } from '../../util/router';

export default function DocumentationLink({ children, hash, ...props }) {
	const router = useRouter();
	const currentPathname = router.location.pathname;
	if(currentPathname.startsWith('/solar/documentation')) {
		return <a href={hash} {...props}>{children}</a>
	}
	return <Link to={`/solar/documentation${hash}`} {...props}>{children}</Link>
}